import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { changeLanguage, cleanStorage } from '../../../../components/helper'
import "./style.scss"
import CustomValuesHookTS from '../../../../Hooks/CustomValuesHookTS'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { CForm, CSpinner } from '@coreui/react'
import { FooterIonSVG } from '../../../../components/IconSvg'
import authService from '../../../../service/reactQueryServices/services/authService'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { useDispatch } from 'react-redux'
import ImageContainer from '../components/imageContainer'

type ErrorResponse = {
    title: string;
};

type SuccessResponse = {
    status: number,
    data: {
        registrationState: string;
        shouldSetPassword: boolean
        registrationCompleted: boolean
    }

};

const TenantMemberRegistration = () => {
    const { mutateAsync: getTenantMemberRegistrationState, error, data, isLoading: getTenantMemberRegistrationStateLoading } =
        useMutation<SuccessResponse, AxiosError<ErrorResponse>, { id: string, token: string }>("getTenantMemberRegistrationState", authService.getTenantMemberRegistrationStateService);
    const { mutateAsync: setTenantMemberUserPassword, data: savePasswordResult, isLoading: setTenantMemberUserPasswordLoading } = useMutation("setTenantMemberUserPassword", authService.setTenantMemberUserPasswordService);

    const [widthScreen, setWidthScreen] = useState(window.innerWidth)
    const params = useParams()
    const [localStates, setLocalStates] = CustomValuesHookTS<any>({ password: '' })
    const { t, i18n } = useTranslation()
    let direction = i18n.dir()
    const dispatch = useDispatch()
    const navigate = useNavigate();


    const validation = Yup.object({
        password: Yup.string().required(t("ERRORS.PASSWORD_REQ") || "").min(8, t("TOAST.PASSWORD_LENGTH_ERROR") || ""),
    })
    useEffect(() => {
        cleanStorage(dispatch).then(() => {
            handleGetState();
        })

    }, [])
    const handleGetState = async () => {

        try {
            const response = await getTenantMemberRegistrationState({ id: params.id || "", token: params.token || "" })
            if (response.status === 200) {
                setLocalStates({ ...response.data })
                if (response.data.registrationCompleted) {
                    toast.success(t("TOAST.ACCEPTATION_SUCCESS"))
                }
            }
        } catch (error: any) {
            // toast.error(error?.response?.data?.title)
        }
    }



    const handleSubmit = async (values: any) => {

        try {
            const response = await setTenantMemberUserPassword(
                {
                    tenantMemberId: params.id,
                    password: values.password,
                    rePassword: values.password,
                    token: params.token
                }
            )
            if (response.status === 200) {
                // toast.success(t("TOAST.ACCEPTATION_SUCCESS"))

            }
        } catch (error) {

        }
    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: {
            password: ''
        },
        onSubmit: handleSubmit,
    })


    return (
        <div className={`d-flex flex-row justify-content-between auth-form tenant-register-page`}>
            <div className='section-right' >
                <div className='d-flex flex-row justify-content-between head-tools-context' >
                    <a href='https://dartamas.com/' className='text-decoration-none'>
                        <button className='btn btn-default main-page-btn' type="button"
                        >{t('MAIN.PAGE_SITE')}</button>

                    </a>
                    <div className='d-flex flex-column justify-content-start' >
                        <div className='d-flex flex-row justify-content-end'>
                            <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={() => changeLanguage(i18n, direction)} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                        </div>
                    </div>
                </div>
                {data &&
                    !getTenantMemberRegistrationStateLoading &&
                    !savePasswordResult &&
                    localStates.shouldSetPassword &&
                    <div className='d-flex flex-row justify-content-center' >

                        <div className='login-section '>
                            <div>
                                <div className='mt-2 mb-2'>
                                    <div className='general-page-title' >{t("TITLES.TENANT_MEMBER_REGISTER")}</div>

                                    <p>{t("DESCTIPTION.TENANT_MEMBER_REGISTER")}</p>
                                </div>
                                {localStates.shouldSetPassword && <CForm onSubmit={formik.handleSubmit} >
                                    <div>
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1" className='d-flex flex-row justify-content-start form-control-label' >{t('LABEL.GET_PASSWORD')} <span className='color-red' >*</span></label>
                                            <input type='password' name="password" id="exampleInputPassword1"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                autoComplete='new-password'
                                                className='form-control' placeholder={t('LABEL.GET_PASSWORD') || ""} />
                                            {formik.errors.password && formik.touched.password && <label className='label-danger '>{formik.errors.password}</label>}
                                        </div>
                                        <div className='login-footer d-flex flex-row justify-content-start'>
                                            <span className='icon-login-footer d-flex flex-column justify-content-center'><FooterIonSVG styles={undefined} /></span>
                                            <div className=' text-login-footer'>
                                                <span>
                                                    {t('FOOTER_LOGIN_TEXT-SECTION_ONE')}
                                                </span>
                                                <a target='_blank' className='link-style' href='https://dartamas.com/privacy-policy/'>{t('LINK_FOOTER')}</a>
                                                <span >‌{t('FOOTER_LOGIN_TEXT-TWO')}</span>
                                            </div>
                                        </div>
                                        <div className='d-flex flex-row justify-content-end'>
                                            <button className="btn btn-primary auth-form-btn"

                                                disabled={!formik.isValid || !formik.dirty || setTenantMemberUserPasswordLoading}
                                                type="submit" >  {(setTenantMemberUserPasswordLoading) ?
                                                    <div className="spinner-border" role="status" aria-hidden="true"></div> : t('TITLE.REGISTER')}</button>

                                        </div>
                                    </div>


                                </CForm>}
                            </div>


                        </div>

                    </div>}
                {getTenantMemberRegistrationStateLoading &&
                    <div className='d-flex justify-content-center align-items-center' >
                        <CSpinner />
                    </div>
                }

                {error && <div className='error-box' >
                    <section>
                        <p>{error.response?.data?.title}</p>
                        <div>
                            <button className='btn btn-primary' onClick={() => navigate("/login")} >{t("ACTIONS.PORTAL_ENTERING")}</button>
                        </div>
                    </section>

                </div>}

                {
                    (savePasswordResult || localStates.registrationCompleted) &&
                    <div className='success-save-password'>
                        <div>
                            <b>{t("TITLES.SUCCESS_SAVE_TENANT_PASSWORD", { name: params.email })}</b>
                            <div>
                                <p>{t("DESCRIPTIONS.SUCCESS_SAVE_TENANT_PASSWORD")}</p>
                            </div>
                                <button className='btn btn-primary' onClick={() => window.location.href = "/login"} >{t("ACTIONS.PORTAL_ENTERING")}</button>
                        </div>

                    </div>
                }
                <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                    <p>{t('COPY_WRITE')}</p>
                </div>
            </div>
            <ImageContainer />

        </div>
    )
}

export default TenantMemberRegistration
